import { render } from "./CompanyStatisticsReport.vue?vue&type=template&id=0bb212bf"
import script from "./CompanyStatisticsReport.vue?vue&type=script&lang=js"
export * from "./CompanyStatisticsReport.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__